import { fade, makeStyles } from '@material-ui/core/styles';

import { COLOR_DIVIDER, COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 28,
      fontSize: theme.typography.pxToRem(14),
      borderColor: COLORS.primary.default,

      '&$interactive': {
        borderColor: COLOR_DIVIDER,

        '&:not($inactive):hover': {
          borderColor: theme.palette.primary.main,
        },
      },

      '&$inactive': {
        borderColor: COLOR_DIVIDER,
      },
    },
    interactive: {},
    inactive: {},

    outlined: {
      '&$deleteIcon': {
        marginRight: '10px',
      },

      '&$inactive': {
        color: COLORS.neutral.mediumLightGray,
      },
    },
    label: {
      paddingLeft: '8px',
      paddingRight: '8px',
    },

    deleteIcon: {
      height: '1em',
      width: '1em',
      padding: '4px',
      fontSize: theme.typography.pxToRem(16),

      '& path': {
        fill: theme.palette.primary.main,

        '$inactive &': {
          fill: COLORS.neutral.mediumLightGray,
        },
      },
      '&:hover': {
        '& path': {
          fill: fade(theme.palette.primary.main, 0.4),

          '$inactive &': {
            fill: COLORS.neutral.mediumGray,
          },
        },
      },
    },
  }),
  { name: 'ChipWord' }
);
